module.exports = __webpack_public_path__ + "3886f52f1f7be3294fbbb0d2b122fd0e.svg";